import { Node } from '../../../../node_modules/tiptap/dist/tiptap.esm.js';
import { panel } from '../../../../node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/panel.js';
import __vue_component__ from '../renderers/Panel.vue.js';

/* eslint-disable */
class Panel extends Node {
  get name() {
    return 'panel';
  }

  get schema() {
    return { ...panel,
      parseDOM: [{
        tag: 'div[data-panel-type]',
        getAttrs: dom => {
          return {
            panelType: dom.getAttribute('data-panel-type'),
            slot: dom
          };
        }
      }]
    };
  }

  get view() {
    return __vue_component__;
  }

}

export default Panel;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/RichTextEditor/custom-extensions/nodes/Panel.js